import React from 'react';
import { FaBullseye, FaEye } from 'react-icons/fa';

const MissionVision = () => {
  return (
    <section id="mission" className="py-16 px-6 bg-gray-100">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Mission */}
          <div className="bg-netbernet-white p-8 rounded-xl shadow-lg">
            <div className="flex items-center mb-6">
              <div className="bg-netbernet-blue p-3 rounded-full mr-4">
                <FaBullseye className="text-2xl text-netbernet-white" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-netbernet-black">Our Mission</h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our belief in not just making an eye-catching design and valuable content, but to market and spread the brand and content to the web and internet community across the globe. We strive to deliver exceptional IT solutions that drive business growth and digital transformation.
            </p>
          </div>
          
          {/* Vision */}
          <div className="bg-netbernet-blue p-8 rounded-xl shadow-lg text-netbernet-white">
            <div className="flex items-center mb-6">
              <div className="bg-netbernet-white p-3 rounded-full mr-4">
                <FaEye className="text-2xl text-netbernet-blue" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold">Our Vision</h2>
            </div>
            <p className="text-lg leading-relaxed">
              We rely on expertise and techniques to make Netbernet your future partner, strong enough to challenge competitive IT services, online marketing, and stand by your side to generate valuable ideas and business solutions. We envision becoming the leading IT solutions provider in the region.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;